export const AuthErrorEnum = Object.freeze({
  SessionExpired: 'SessionExpired',
  AccountNotConfirmed: 'AccountNotConfirmed',
  InvalidCredentials: 'InvalidCredentials',
});
